import { render, staticRenderFns } from "./NewStoryboardForm.vue?vue&type=template&id=60e4515c&scoped=true"
import script from "./NewStoryboardForm.vue?vue&type=script&lang=js"
export * from "./NewStoryboardForm.vue?vue&type=script&lang=js"
import style0 from "./NewStoryboardForm.vue?vue&type=style&index=0&id=60e4515c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e4515c",
  null
  
)

export default component.exports